import * as validator from 'validator';
import isEmpty from 'lodash/isEmpty';

export default function validateInput(data) {
  let errors = {};
  /*if (validator.isEmpty(data.Orgnr)) {
    errors={
        ...errors,
        Orgnr:'This field is required'
    }
  }
*/
  if (!validator.isEmail(data.email)) {
    errors={
        ...errors,
        email:'This field is required'
    }
  }
  return {
    errors:errors,
    isValid: isEmpty(errors)
  };
}